import NextImage from 'next/image';
import type { ComponentProps } from 'react';
import { useState } from 'react';

const failedImageUrls = new Set<string>();

function Image({
  fallbackComponent,
  fallbackImageUrl,
  // Defaults true so every existing caller's DOM is unchanged; a caller in a long list (e.g. a table
  // row) passes false so it does not preload every row.
  priority = true,
  unoptimized = true,
  ...rest
}: ComponentProps<typeof NextImage> & {
  fallbackComponent?: JSX.Element | null;
  fallbackImageUrl?: string;
}) {
  const src = String(rest.src);
  const [isError, setIsError] = useState(() => failedImageUrls.has(src));

  if (isError && (fallbackImageUrl || fallbackComponent !== undefined)) {
    return fallbackImageUrl ? (
      <NextImage {...rest} src={fallbackImageUrl} priority={priority} unoptimized />
    ) : (
      (fallbackComponent ?? null)
    );
  }

  return (
    <NextImage
      {...rest}
      priority={priority}
      unoptimized={unoptimized}
      onError={() => {
        failedImageUrls.add(src);
        setIsError(true);
      }}
    />
  );
}

export default Image;
